import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Bell } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button, Card } from "./ui";
import { intlLocale } from "@/lib/i18n";

/** Hauptschalter: E-Mail-Benachrichtigungen an Kunden (erst nach Ankündigung einschalten) */
export function CustomerNotificationsCard() {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ["admin-customer-notifications"], queryFn: api.admin.customerNotifications });
  const set = useMutation({
    mutationFn: (enabled: boolean) => api.admin.setCustomerNotifications(enabled),
    onSuccess: (r) => { toast.success(r.enabled ? "Benachrichtigungen an Kunden eingeschaltet" : "Benachrichtigungen an Kunden ausgeschaltet"); void qc.invalidateQueries({ queryKey: ["admin-customer-notifications"] }); },
    onError: () => toast.error("Konnte nicht gespeichert werden"),
  });
  if (!q.data) return null;
  const on = q.data.enabled;
  return (
    <Card className="mt-4 p-4 flex flex-wrap items-center gap-3">
      <Bell className="size-4 text-fg-subtle" />
      <div className="min-w-0 flex-1 basis-72">
        <p className="font-medium text-[13.5px]">E-Mail-Benachrichtigungen an Kunden: {on ? <span className="text-success">eingeschaltet</span> : <span className="text-fg-muted">aus</span>}</p>
        <p className="text-[12.5px] text-fg-muted">
          {on
            ? `Seit ${q.data.since ? new Date(q.data.since).toLocaleString(intlLocale()) : "—"}: Kunden bekommen Handlungsbedarf sofort/täglich und den Wochenbericht – wie jeder Nutzer es eingestellt hat.`
            : "Kunden können ihre Einstellungen schon festlegen; versendet wird erst nach dem Einschalten. Beim Einschalten gibt es keine Flut: gemeldet wird nur, was danach neu hinzukommt."}
        </p>
      </div>
      <Button variant={on ? "secondary" : "primary"} loading={set.isPending} onClick={() => { if (on || confirm("Benachrichtigungen an alle Kunden einschalten? Ab dann gehen E-Mails an Kunden-Nutzer (Standard: Dringendes sofort, Zusammenfassung werktags 7 Uhr, Wochenbericht montags).")) set.mutate(!on); }}>
        {on ? "Ausschalten" : "Einschalten"}
      </Button>
    </Card>
  );
}
